import React from 'react';
import Skeleton from 'react-loading-skeleton';

type Props = {
    count?: number;
};

const AmountSelectorsSkeletons: React.FC<Props> = ({ count = 2 }) => {
    return (
        <fieldset className="sgw-radio-button-panels">
            <legend className="sgw-radio-button-legend">
                <Skeleton className="sgw-radio-button-legend-text" height={27} width={200} />
            </legend>
            {Array.from(Array(count)).map((_, index) => (
                <Skeleton
                    // eslint-disable-next-line react/no-array-index-key
                    key={`amount-selector-skeleton-${index}`}
                    height={76}
                    width="100%"
                />
            ))}
        </fieldset>
    );
};

export default AmountSelectorsSkeletons;
